<template>
  <div>
    <div id="map" />
    <MapUI @zoom="handleMapNav"/>
  </div>
</template>

<script>
import _Mapbox from '@/plugins/mapbox';

import MapUI from '@/components/ui/MapUI';

export default {
  name: 'Map',
  components: {
    MapUI,
  },
  data() {
    return {
      map: null,
    }
  },
  computed: {
    defaultOptions() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return {
          container: 'map',
          style: 'mapbox://styles/foodscapepages/ckw0fcu8w0d5014qkfzc05x9g',
          center: [109, 7],
          zoom: 3,          
        };
      }
      return {
        container: 'map',
        style: 'mapbox://styles/foodscapepages/ckw0fcu8w0d5014qkfzc05x9g',
        center: [101, 9.52],
        zoom: 3.25,
      };
    },
  },
  watch: {
    panelState(newVal) {
      if (newVal === '') {
        this.resetMap();
      }
    }, 
  },
  async mounted() {
    // init Mapbox
    this.map = _Mapbox.createMap(this.defaultOptions);

    await this.map.on('load', () => {
        this.handleInteractivity();
    }); 
  },
  methods: {  
    handleInteractivity() {
      this.popUp = _Mapbox.createPopup({ closeButton: false, className: 'tooltip' });

      this.map.on('click', 'symbols', e => {
        const coord = e.features[0].geometry.coordinates;       

        // map action
        this.map.flyTo(this.$vuetify.breakpoint.mdAndUp ? {center: [coord[0] - 0.2, coord[1]], zoom: 10} : {center: [coord[0], coord[1] - 0.12], zoom: 10}
        )  

        this.$emit('update-panel', '--is-open')
        this.$emit('update-data', e.features[0].properties)
      });

      if (this.$vuetify.breakpoint.smAndDown) {
        this.map.on('click', 'symbols', this.handleMapPopup);        
      }      

      if (this.$vuetify.breakpoint.mdAndUp) {
        this.map.on('mouseover', 'symbols', this.handleMapPopup);          
        this.map.on('mouseleave', 'symbols', this.handleLayerExit);
      }      
    },
    handleMapPopup(e) {      
      this.map.getCanvas().style.cursor = 'pointer';
      const coordinates = e.features[0].geometry.coordinates.slice();
      const name = e.features[0].properties.name;
      this.popUp
        .setLngLat(coordinates)
        .setHTML(`<p class="text-nav-anchor mb-0">${name}</p>`)
        .addTo(this.map);
    },     
    handleLayerExit() {
      this.map.getCanvas().style.cursor = '';
      this.popUp.remove();
    },
    handleMapNav($event) {
      if ($event === 'in') {
        this.map.zoomIn();
      } else if ($event === 'out') {
        this.map.zoomOut();
      } else if ($event === 'reset') {
        this.resetMap();
      }
    },
    resetMap() {
      this.map.getZoom() !== 2.5 ? 
      this.map.flyTo({ center: [101, 9.52], zoom: 3.25}) : '';

      if (this.$vuetify.breakpoint.smAndDown) {
        this.map.flyTo({ center: [109, 7], zoom: 3});
      }        
    },
  }        
};
</script>

<style lang="scss" scoped>
@import '~mapbox-gl/dist/mapbox-gl.css';
@import '~vuetify/src/styles/settings/_variables.scss';

#map {
  width: 100%;
  height: 100%;
  position: relative;

  ::v-deep .mapboxgl-popup-content {
    font-family: 'Gordita Bold', sans-serif !important;
    max-width: 200px;
    background-color: #FAF7F5;
    font-size: 14px;
    line-height: 20px;
    color: #2A2929; 
    margin-bottom: 0px;
    text-align: center;
    .popup-img {
      display: block;
      margin: 0 auto;
    }    
  }  
}
</style>


  